import { Checkbox, FormControlLabel } from '@mui/material';
import { Controller } from 'react-hook-form';

export default function ControllerCheckBox(props) {
   const { control, name, className, label, labelPlacement, style = {}, disabled = false, onChange } = props;

   return (
      <FormControlLabel
         label={label}
         labelPlacement={labelPlacement || 'end'}
         className={className || null}
         key={label.value}
         control={
            <Controller
               name={name}
               control={control}
               label={label}
               render={({ field }) => {
                  return (
                     <Checkbox
                        disabled={disabled}
                        checked={field.value}
                        onChange={(ev) => {
                           if (onChange) {
                              field.onChange(ev.target.checked);
                              onChange(ev);
                           } else {
                              field.onChange(ev.target.checked);
                           }
                        }}
                        disableRipple
                        size="small"
                        style={style || null}
                     />
                  );
               }}
            />
         }
      />
   );
}
